module.exports = __webpack_public_path__ + "img/scurve-abl-min.2a6fd810.png";